import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {IssueTicketDTO} from '../../clm/models/IssueTicketDTO';

@Injectable({
  providedIn: 'root'
})
export class IssueTicketService {

  private url = environment.baseItsUrl + '/issue-ticket';

  constructor(private httpClient: HttpClient) { }

  getListOfIssueTickets(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<IssueTicketDTO>> {
    return this.httpClient.post<PagedResponseDTO<IssueTicketDTO>>(this.url  + '/filter', pagedRequestDTO);
  }

  getIssueTicket(providerId: number): Observable<IssueTicketDTO> {
    return this.httpClient.get<IssueTicketDTO>(this.url + '/' + providerId);
  }

  deleteIssueTicket(id: number) {
    return this.httpClient.delete<{}>(this.url + '/' + id);
  }

  saveIssueTicket(issueTicketDTO: IssueTicketDTO): Observable<IssueTicketDTO> {
    return this.httpClient.post<IssueTicketDTO>(this.url, issueTicketDTO);
  }
}
